// Recovered compiled webpack factory 58130. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "shouldHardNavigate", {
      enumerable: !0,
      get: function () {
        return function e(t, r) {
          let [o, i] = r,
            [s, l] = t;
          return (0, a.matchSegment)(s, o)
            ? !(t.length <= 2) && e((0, n.getNextFlightSegmentPath)(t), i[l])
            : !!Array.isArray(s);
        };
      },
    }));
  let n = r(16378),
    a = r(7460);
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
